import { Form, Input, Select } from "antd";
import { useEffect, useState } from "react";
import { api } from "../common/api";
import { filterOption, requiredField } from "../common/common";

export default function DpiProductFields() {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api.dpi
      .list({ pageSize: 9999 })
      .then(({ data }) => {
        if (active) setTypes(data.map((dpi) => ({ label: dpi.name, value: dpi.id })));
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <>
      <Form.Item name="dpiId" label="Categoria" rules={[requiredField]}>
        <Select showSearch filterOption={filterOption} options={types} loading={loading} />
      </Form.Item>
      <Form.Item name="sku" label="SKU" rules={[requiredField]}>
        <Input />
      </Form.Item>
      <Form.Item name="description" label="Descrizione" rules={[requiredField]}>
        <Input />
      </Form.Item>
      <Form.Item name="supplier" label="Fornitore">
        <Input />
      </Form.Item>
      <Form.Item name="supplierCode" label="Cod. articolo fornitore">
        <Input />
      </Form.Item>
      <Form.Item name="color" label="Colore">
        <Input />
      </Form.Item>
      <Form.Item name="size" label="Taglia">
        <Input />
      </Form.Item>
    </>
  );
}
